import get from 'lodash/get';
import { feedBack } from '../actionTypes';

const successFetchingFeedBackDetailsWidgets = payload => ({
  type: feedBack.SUCCESS_FETCHING_FEEDBACK_DETAILS_WIDGETS,
  payload
});

const errorFetchingFeedBackDetailsWidgets = payload => ({
  type: feedBack.FAILURE_FETCHING_FEEDBACK_DETAILS_WIDGETS,
  payload
});

export const fetchfeedbackdetailswidgets = () => dispatch => {
  dispatch({
    hmsFetchConfig: {
      path: '/hms_ms/api/v1/generic/campaign_page_widgets_v2',
      method: 'POST',
      queryParams: {
        page_type: 'medallia_feedback_details',
        campaign: 'config',
        clear_cache: true
      }
    },
    onSuccess: ({ data }) => {
      const feedback_details_widget_data = get(data, 'data.widget_list[0]', []);
      dispatch(successFetchingFeedBackDetailsWidgets({ feedback_details_widget_data }));
    },
    onError: ({ error }) => {
      dispatch(errorFetchingFeedBackDetailsWidgets({ error }));
    }
  });
};
